import { render, staticRenderFns } from "./deliveryChallan.vue?vue&type=template&id=7996c1ee"
import script from "./deliveryChallan.vue?vue&type=script&lang=js"
export * from "./deliveryChallan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports